import { useState } from "react"

import { Button } from "react-bootstrap"
import { FaReply, FaTimes } from "react-icons/fa"
import { toast } from "react-toastify"
import { finalize } from "rxjs/operators"

import PoolSelectionRerunModal from "./PoolSelectionRerunModal"
import { PoolSelectionCancel, PoolSelectionCancelObservable } from "../../../api/Randoms/PoolSelectionActions"
import PoolSelectionRow from "../../../api/Randoms/RandomsModel/PoolSelectionRow"
import handleAPIError from "../../../utils/handleAPIError"
import ActionButton from "../../ActionButton"
import ConfirmationModal from "../../ConfirmationModal"

interface PoolSelectionActionButtonsProps {
  poolId: number
  companyId: number
  row: PoolSelectionRow
  onRefresh: () => void
}

function PoolSelectionActionButtons(props: PoolSelectionActionButtonsProps) {
  const { poolId, companyId, row, onRefresh } = props
  const [canceling, setCanceling] = useState(false)
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false)
  const [showRerunModal, setShowRerunModal] = useState(false)

  if (!row.IsActive) {
    return null
  }

  const handleCancel = () => {
    setCanceling(true)
    setShowCancelConfirmation(false)
    const poolSelection : PoolSelectionCancel = {PoolSelectionID : row.PoolSelectionID}
    PoolSelectionCancelObservable(poolSelection)
      .pipe(finalize(() => setCanceling(false)))
      .subscribe(
        (data) => {
          onRefresh()
          toast.success(data)
        },
        (error) => handleAPIError(error, () => {})
      )
  }

  return (
    <>
      {row.Status === 0 && (
        <ActionButton
          variant="link"
          className="py-0"
          onClick={() => setShowCancelConfirmation(true)}
          spin={canceling}
          disableOnSpin
        >
          <FaTimes />
          <span className="ml-1">Cancel</span>
        </ActionButton>
      )}
      {row.Status === 1 && (
        <Button variant="link" className="py-0" onClick={() => setShowRerunModal(true)}>
          <FaReply />
          <span className="ml-1">Re-run</span>
        </Button>
      )}
      <ConfirmationModal
        show={showCancelConfirmation}
        title="CANCEL CONFIRMATION"
        textTitle="You are about to cancel an active Selection."
        text=" This cannot be undone. Are you sure you want to proceed?"
        confirmButtonText="Yes, cancel selection"
        cancelButtonText="No, do not cancel selection"
        onConfirm={handleCancel}
        onHide={() => setShowCancelConfirmation(false)}
      />
      {showRerunModal && (
        <PoolSelectionRerunModal
          onHide={() => setShowRerunModal(false)}
          onRefresh={onRefresh}
          row={row}
          poolId={poolId}
          companyId={companyId}
        />
      )}
    </>
  )
}
export default PoolSelectionActionButtons
